import TpkSelectLabel from '../tpk-select/label';
export default class TpkSearchSelectLabel extends TpkSelectLabel {}